import { Cell } from '@/shared/ui/primitives';
import type { FC } from 'react';
import type { Pass } from '@/types';
import { CreditBadge } from '@/shared/ui';
import { TEST_ID_BUILDERS } from '@/testIds';
import { formatDateForDisplay } from '@/shared/lib/calendarDate';

interface PassListItemProps {
  pass: Pass;
  onClick: (pass: Pass) => void;
}

export const PassListItem: FC<PassListItemProps> = ({ pass, onClick }) => {
  const getPassStatus = (): { text: string; status: 'dated' | 'unlimited' } => {
    const startDateStr = formatDateForDisplay(pass.startsAt);

    if (pass.endsAt) {
      const endDateStr = formatDateForDisplay(pass.endsAt);
      return { text: `${startDateStr} - ${endDateStr}`, status: 'dated' };
    } else {
      return { text: `${startDateStr} - No expiry`, status: 'unlimited' };
    }
  };

  const status = getPassStatus();
  return (
    <Cell
      data-testid={TEST_ID_BUILDERS.passByName(pass.name)}
      trailing={<CreditBadge pass={pass} />}
      subtitle={status.text}
      onClick={() => onClick(pass)}
    >
      {pass.name}
    </Cell>
  );
};
